import { Reveal, Eyebrow } from "./Reveal";

const DISCIPLINES = [
  {
    num: "I",
    id: "oil",
    name: "Oil Painting",
    technique: "Layered Glazes & Chiaroscuro",
    description:
      "Rich, luminous textures layered on heavy canvas, bringing depth, longevity, and archival prestige to every original composition.",
  },
  {
    num: "II",
    id: "acrylic",
    name: "Acrylic Works",
    technique: "Vibrant Impasto & Modern Textures",
    description:
      "Dynamic, expressive brushstrokes and vivid chromatic balances crafted specifically for modern interiors and curated living spaces.",
  },
  {
    num: "III",
    id: "custom",
    name: "Custom Artwork",
    technique: "Narrative Synthesis & Bespoke Detail",
    description:
      "Bespoke artwork transformed from cherished photographs, personal milestones, and conceptual narratives tailored to collectors.",
  },
];

export default function Disciplines() {
  return (
    <section id="disciplines" className="bg-cream-deep/60 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow>Artistic Disciplines</Eyebrow>
          <h2 className="mt-6 max-w-xl font-serif text-3xl tracking-tight text-ink sm:text-5xl lg:text-6xl">
            Three ways I work.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8">
          {DISCIPLINES.map((d, i) => (
            <Reveal key={d.id} delay={i * 0.1} className="h-full">
              <div
                data-testid={`discipline-card-${d.id}`}
                className="group h-full border-l border-linen pl-6 transition-colors duration-500 hover:border-vermilion sm:pl-8"
              >
                <p className="font-serif text-4xl italic text-gild/70">{d.num}</p>
                <h3 className="mt-6 font-serif text-2xl tracking-tight text-ink sm:text-3xl">
                  {d.name}
                </h3>
                <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.24em] text-vermilion">
                  {d.technique}
                </p>
                <p className="mt-5 text-sm leading-relaxed text-clay sm:text-base">
                  {d.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
